export default __webpack_public_path__ + "media/5652dfeb7d9d83d566a4964eb45e0d8045eccba554c43d5a5a22a30201f5b5dd.svg";